/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} About_Value_Improvement_TextInputs */



/**
* | output |
* | --- |
* | "Regular training and knowledge sharing to keep our reporting sharp." |
*
* @param {About_Value_Improvement_TextInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
export const about_value_improvement_text = /** @type {((inputs?: About_Value_Improvement_TextInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<About_Value_Improvement_TextInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return /** @type {LocalizedString} */ ("定期培训和分享知识，让我们的报告始终保持高水准。")
	return /** @type {LocalizedString} */ ("Regular training and knowledge sharing to keep our reporting sharp.")
});